import { isEmpty } from "lodash";
import { Dispatch } from "react";
import { apiBaseUrl, networkCall } from "../../utils/networkCall";

export const ADD_SMS_TEMPLATE: string = "ADD_SMS_TEMPLATE";
export const CLEAR_SMS_TEMPLATES: string = "CLEAR_SMS_TEMPLATES";
export const DELETE_TEMPLATE_IDS = "DELETE_TEMPLATE_IDS";
export const DELETE_TEMPLATE_TITLE = "DELETE_TEMPLATE_TITLE";

export const GET_DATA: string = "GET_DATA";

export function addSMSTemplate(templateId: string, channelId: number, name: string, status: number): IAddSMSTemplateActionType {
    return { type: ADD_SMS_TEMPLATE, templateId: templateId, channelId: channelId, name: name, status: status }
}
export function clearSMSTemplates(): IClearSMSTemplateActionType {
    return { type: CLEAR_SMS_TEMPLATES };
}
export function deleteTemplateIds(ids: string[], title: string): IDeleteTemplateIds {
    return { type: DELETE_TEMPLATE_IDS, payload: ids , title: title }
}
export function deleteTemplateTitle(): any {
    return { type: DELETE_TEMPLATE_TITLE}
}

export const getData = () => {
    return (dispatch: Dispatch<any>) => {
        networkCall("get", `/messages/configuration/template`, apiBaseUrl.baseUrl)
            .then((res: any) => {
                if (isEmpty(res.error)) {
                    dispatch({ type: GET_DATA, payload: res });
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    console.log(error.response)
                }
            });
    }
}

export const deleteTemplate = (data: any, cb: any) => {
    return () => {
        networkCall("delete", `/messages/template/bulk-delete`, apiBaseUrl.baseUrl, true, true, data)
            .then((res: any) => {
                if (!isEmpty(res.data.error)) {
                    cb(res, false)
                } else {
                    cb(res, true)
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    cb(error, false)
                    console.log(error.response)
                }
            });
    }
}

export const documentUpload = (
    data: any,
    cb: (response: any, statusFlag: boolean) => void,
    onError: () => void,
) => {
    return () => {
        let url: string = `/messages/template/bulk-upload`;
        networkCall('post', url, apiBaseUrl.baseUrl, true, true, data)
            .then((res: any) => {
                if (isEmpty(res.error)) {
                    cb(res, true);
                } else {
                    cb(res, false)
                }
            }).catch(() => {
                onError();
            });
    };
};

interface IAddSMSTemplateActionType { 
    type: string, 
    templateId: string, 
    channelId: number, 
    name: string, 
    status: number 
}

interface IClearSMSTemplateActionType { 
    type: string 
}

interface IDeleteTemplateIds { 
    type: string, 
    payload: string[],
    title: string
}